<template lang="pug">
  .farm-history
    router-view
</template>

<script>
export default {
  name: 'FarmHistory'
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_mixins.scss';

.farm-history {
  margin-top: 6.5rem;

  @include tablet {
    margin-top: 0;
  }
}
</style>
